import { useUnread } from '../context/unread.context'
import Colors from '../constants/Colors'
import { View, StyleSheet, Pressable, Text, Modal } from 'react-native'
import React, { useContext, useState } from 'react'

interface UnreadBadgeProps {
  handleOpen: (value: boolean) => void
}

const UnreadBadge = ({ handleOpen }: UnreadBadgeProps) => {
  const { unreadItems } = useUnread()
  const unreadMessageCount = unreadItems.unreadArticles.length

  if (!unreadMessageCount) return <View style={{ margin: 8 }}></View>

  return (
    <Pressable style={styles.badge} onPress={() => handleOpen(true)}>
      <Text style={styles.badgeText}>
        {unreadMessageCount > 999 ? '1k+' : unreadMessageCount}
      </Text>
    </Pressable>
  )
}

export default UnreadBadge

const styles = StyleSheet.create({
  badge: {
    backgroundColor: Colors.notificationRed,
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 8,
    margin: 8,
  },
  badgeText: { color: Colors.white, fontWeight: '700', fontSize: 16 },
  centeredView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalView: {
    margin: 20,
    backgroundColor: 'white',
    borderRadius: 20,
    padding: 35,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
})
